export const Questions = [
    {
        id: 1,
        description: "Are you sure you want to do this?"
    },
    {
        id: 2,
        description: "Are you sure you want to delete these details?"
    },
    {
        id: 3,
        description: "Are you sure you want to change these details?"
    },
    {
        id: 4,
        description: "Details have been changed. Do you want to save the modifications?"
    },
    {
        id: 5,
        description: "The following Contacts have been found with a similar name to the Contact you are adding. Click 'YES' to continue adding this Contact or 'NO' to modify one of the existing Contacts?"
    },
    {
        id: 6,
        description: "Do you wish to update the existing Macro? If you answer 'No' you can save as a New Macro."
    },
    {
        id: 7,
        description: "Do you want to automatically add a Filter to only include Contacts on the Mailing List?"
    },
    {
        id: 8,
        description: "Do you want to automatically add a Filter to only include Contacts on the Emailing List?"
    },
    {
        id: 9,
        description: "Your database requires updating to match this version of Acquaint. Do you want to continue? (please ensure that all other users exit from Acquaint)"
    },
    {
        id: 10,
        description: "Are you sure you want to copy these details?"
    },
    {
        id: 11,
        description: "The following Contacts have been found with a similar email address to the Contact you are adding. Click 'YES' to continue adding this Contact or 'NO' to modify one of the existing Contacts?"
    },
    {
        id: 12,
        description: "A copy of this document was not saved against the contact. Do you want to re-produce the document (this will appear as another item in this list)?"
    },
    {
        id: 13,
        description: "Property pictures should be less then 60KB in size to ensure they can be uploaded to internet portals. This picture is larger. Do you want to resize it automatically?"
    },
    {
        id: 14,
        description: "You have changed details. The function you have selected will work using the previously saved information unless you Save these changes. Do you want to save the changes now?"
    },
    {
        id: 15,
        description: "Do you wish to use the Contacts home address as the address for this property?"
    },
    {
        id: 16,
        description: "Do you wish to update the address of the purchasers/tenants with the address of their new property?"
    },
    {
        id: 17,
        description: "Do you want to automatically add a Filter to only include Contacts on the SMS Text List?"
    },
    {
        id: 18,
        description: "The database you are attempting to connect to does not appear to exist. Would you like to try and create a new blank database?"
    },
    {
        id: 19,
        description: "You have deleted the file from the property but do you want to delete this file from your hard disk as well?"
    },
    {
        id: 20,
        description: "This image does not exist in the Acquaint Image folder. Do you want to move it there?"
    },
    {
        id: 21,
        description: "Would you like to add yourself as an attendee of this Appointment?"
    },
    {
        id: 22,
        description: "Would you like to create a Valuation Appointment for this Property now?"
    },
    {
        id: 23,
        description: "Do you want to modify the database configuration settings?"
    },
    {
        id: 24,
        description: "Saving these new Tenancy details will create Account transactions against this contact. Please ensure that you have previewed and checked the Payments Schedule tab. Do you wish to continue saving?"
    },
    {
        id: 25,
        description: "Do you want to create a payment (credit) for this transaction?"
    },
    {
        id: 26,
        description: "You are filtering Diary Appointments for a specific User. Do you want to remove this filter?"
    },
    {
        id: 27,
        description: "Do you want to produce a new Statement (Yes) or reprint a previous Statement (No) ?"
    },
    {
        id: 28,
        description: "Were your Statements correct and have they been successfully produced?"
    },
    {
        id: 29,
        description: "You have reduced the length of the Tenancy. Rent Due Transactions past the new End Date will be automatically deleted. Are you sure you want to do this?"
    },
    {
        id: 30,
        description: "This process will undo the last Statement produced for this Contact and allow you to modify the transactions that were included on it. Are you sure you want to do this?"
    },
    {
        id: 31,
        description: "There are Transactions for this Tenancy that have already been included on Statements, Bank Reconciliations or have been Transferred as Fees. Please note that transactions will NOT be deleted - you will need to manually review/adjust the Landlord and Tenant Accounts. Are you sure you want to continue?"
    },
    {
        id: 32,
        description: "Do you want to update the Property Marketing Date to today? This will also increase the Contract Expiry Date based on your default Contract period."
    },
    {
        id: 33,
        description: "Are you making a Rent Payment?"
    },
    {
        id: 34,
        description: "These particulars already exist for this Property. Are you sure you want to re-create them?"
    },
    {
        id: 35,
        description: "Was there a charge associated with this Work Order?"
    },
    {
        id: 36,
        description: "Path has changed. Do you want to update existing records to use the new Path?"
    },
    {
        id: 37,
        description: "This process cannot be undone. Are you really sure you want to delete this Property?"
    },
    {
        id: 38,
        description: "This process cannot be undone. Are you really sure you want to delete this Contact?"
    },
    {
        id: 39,
        description: "Do you want to run the Macro now (Yes) or edit it first (No) ?"
    },
    {
        id: 40,
        description: "The following Properties have been found with a similar address to the Property you are adding. Click 'YES' to continue adding this Property or 'NO' to modify one of the existing Properties?"
    },
    {
        id: 41,
        description: "You have NOT set a commission to charge to the Landlord. Are you really sure you want to create a Tenancy where no commission is charged?"
    },
    {
        id: 42,
        description: "You have changed the End Date of the Tenancy. You will need to manually adjust the Tenants account to reflex this (i.e increase or decrease their payments) . Do you want to do this now?"
    },
    {
        id: 43,
        description: "Would you like to produce a deposit account statement for the Tenant?"
    },
    {
        id: 44,
        description: "Would you like to add this Contact's Property now?"
    },
    {
        id: 45,
        description: "The Contact does not have an email address. Would you like to add one now?"
    },
    {
        id: 46,
        description: "Your file has been created. Would you like to open it now?"
    },
    {
        id: 47,
        description: "Undoing an Invoice will delete the Invoice record but leave the transactions in place. Are you sure you want to do this?"
    },
    {
        id: 48,
        description: "Deleting an Invoice will delete the Invoice and all the transactions included. Are you sure you want to do this?"
    },
    {
        id: 49,
        description: "Sorry, you do not have enough credits to send SMS Text messages. Would you like to purchase more credits now?"
    },
    {
        id: 50,
        description: "Would you like to print the Invoice now?"
    },
    {
        id: 51,
        description: "The amount of Credit selected is less than the Amount Due. If you continue a part payment will be made and a new Unpaid Transaction will be created for the balance. Are you sure you want to do this?"
    },
    {
        id: 52,
        description: "Would you like to move this file to Acquaint Document folder? This will ensure the file is available to all Users."
    },
    {
        id: 53,
        description: "You require a newer Version of Acquaint to access this database. Do you want to check for Version Updates now?"
    },
    {
        id: 54,
        description: "Would you like to print a Receipt now for these payments?"
    },
    {
        id: 55,
        description: "A newer version of Acquaint is available. Updating your PC will also force all other Users to install the new version. Would you like to install now?"
    },
    {
        id: 56,
        description: "Do you want to add this new area to your current applicants property requirements? If you don't do this then they will not be matched against this area."
    },
    {
        id: 57,
        description: "Running the Collation Report with update Contacts with details of the Properties to be posted to them. Please ensure you have produced Address Labels / Letters beforehand. Are you sure you want to continue?"
    },
    {
        id: 58,
        description: "Are you sure you want to undo posting records against all Properties for today?"
    },
    {
        id: 59,
        description: "You have changed the selected Report. Would you like to clear the Filters you have entered?"
    },
    {
        id: 60,
        description: "Were your Statements correct and have they been successfully produced? If you say \"NO\" then the Charge you made to each Contact will be removed."
    },
    {
        id: 61,
        description: "Are you sure you want to copy this Contact?"
    },
    {
        id: 62,
        description: "This image does not exist in your shared Acquaint folders, it therefore may not be available to other Users. Do you want Acquaint to make a copy of the image?"
    },
    {
        id: 63,
        description: "Properties have been added or changed. Do you want to upload them to the internet now?"
    },
    {
        id: 64,
        description: "Undoing a Receipt will delete the Receipt record but leave the transactions in place. Are you sure you want to do this?"
    },
    {
        id: 65,
        description: "Would you like Acquaint to synchronise your Acquaint Diary with your Outlook Calendar?  This feature is useful if you want to transfer your Appointments to a Mobile Phone e.g. a Blackberry, or PDA.  You can switch this feature on/off from your Contact record on the User Settings screen if you are unsure now."
    },
    {
        id: 66,
        description: "The file size of the image you are inserting into the email is larger than we would recommend. If you make your email too large it will take a long time to send and receive. Do you want to continue?"
    },
    {
        id: 67,
        description: "Deleting this will also delete other transactions held on other accounts (i.e. Contact / Company Account ). Are you sure you want to do this?"
    },
    {
        id: 68,
        description: "This contact is a Link. Would you prefer to use the Primary record instead?"
    },
    {
        id: 69,
        description: "Do you want this document to reference the following property?"
    },
    {
        id: 70,
        description: "You have changed the commission charged for managing this property. Do you want to update any existing unpaid Rent transactions to reflect this?"
    },
    {
        id: 71,
        description: "Were your Rent Demands correct and have they been successfully produced?"
    },
    {
        id: 72,
        description: "You have changed the address. Would you like Acquaint to re-calculate the map position?"
    },
    {
        id: 73,
        description: "Would you like to pass this charge onto the property owner or another contact?"
    },
    {
        id: 74,
        description: "Bills have been paid. A credit export file has been created with account details and payments ready to import into your banking software. Would you like to produce a report of these payments?"
    },
    {
        id: 75,
        description: "Acquaint needs to convert your Contact & Property addresses into a new format. This many take a few minutes. Do you want to do this now?"
    },
    {
        id: 76,
        description: "Would you like to print a Key Sign Out form?"
    },
    {
        id: 77,
        description: "Would you like to print an Invoice for these fees?"
    },
    {
        id: 78,
        description: "Do you wish to transfer a single lump sum or select individual transactions to transfer?"
    },
    {
        id: 79,
        description: "Warning. Attaching a document here will result in it being uploaded to the internet as Property Particulars. Are you sure you want to do this?"
    },
    {
        id: 80,
        description: "Do you want to Refund the following transaction? If you answer \"No\" you will be Refunding directly from the Company account."
    },
    {
        id: 81,
        description: "This property isn't Available. Are you sure you want to Match Applicants against it?"
    },
    {
        id: 82,
        description: "You are changing the deposit to be held by the Landlord. When you save the Tenancy the Deposit will be transferred to the Landlord’s account. You will not be able to reverse this operation. Are you sure you want to do this?"
    },
    {
        id: 83,
        description: "You are increasing the Deposit amount. Please note you will manually need to add an additional Deposit transaction to the Tenants client account. Are you sure you want to do this?"
    },
    {
        id: 84,
        description: "You are decreasing the Deposit amount. Please note you will manually need to check and possibly refund money to the Tenant. Are you sure you want to do this?"
    },
    {
        id: 85,
        description: "Have you finished making your payments?"
    },
    {
        id: 86,
        description: "Errors are occuring. Do you want to abort the transfer?"
    },
    {
        id: 87,
        description: "Rent is being paid early. Do you want to transfer this to the Landlord now (answer \"Yes\"). If you answer \"No\" then the Rent will be held until its Due Date."
    },
    {
        id: 88,
        description: "The UK Standard VAT rate has been increased from 17.5% to 20% from 4th Jan 2011. Do you want Acquaint to update your Products to reflect this now?"
    },
    {
        id: 89,
        description: "This Contact already has a Tenancy in place for this Property. If you are extending the Tenancy then you should edit the existing Tenancy and increase the number of months. Do you want to do this now?"
    },
    {
        id: 90,
        description: "The Property Wizard Importer has not been installed. Would like to download and install it now?"
    },
    {
        id: 91,
        description: "This Short Code SMS is already assigned to a property. Do you want to transfer the Short Code SMS to this property?"
    },
    {
        id: 92,
        description: "You are exiting without producing any Statements. You should produce Statements for the Payments you have made. Are you sure you want to exit?"
    },
    {
        id: 93,
        description: "Is the owner of the Property new to you (i.e we need to add them as a new Contact first)?"
    },
    {
        id: 94,
        description: "Do you want to make a charge for the Registration Fee now?"
    },
    {
        id: 95,
        description: "Do you want to receive the Booking Deposit now?"
    },
    {
        id: 96,
        description: "Presentation had been created. Would you like to open the folder and view the files?"
    },
    {
        id: 97,
        description: "You are reducing the length of the Tenancy. Is this because the Tenant is terminating the agreement and leaving early?"
    },
    {
        id: 98,
        description: "The following Contacts have been found with a similar mobile telephone to the Contact you are adding. Click 'YES' to continue adding this Contact or 'NO' to modify one of the existing Contacts?"
    },
    {
        id: 99,
        description: "You have reduced the term of the Tenancy. Do you want to set the Status of the Tenancy to \"Tenant Leaving\"?"
    },
    {
        id: 100,
        description: "An offer has been added against the Property and transactions have been added to the Tenants account. Would you like to perform an online reference?"
    },
    {
        id: 101,
        description: "Would you like to assign this Letterhead to your Letter Templates?"
    },
    {
        id: 102,
        description: "Do you want to re-market the property now? The property will be set as available from:"
    },
    {
        id: 103,
        description: "You haven't selected a Board Supplier yet. Do you want to do this now?"
    },
    {
        id: 104,
        description: "Do you want to Transfer or Partially Transfer the following transaction? If you answer \"No\" you can Transfer a definable amount."
    },
    {
        id: 105,
        description: "This transaction is part of a batch transfer. Are you sure you want to undo the transfer?"
    },
    {
        id: 106,
        description: "The Balance on this Account may be incorrect. Would you like to set an Opening Balance to correct the figures?"
    },
    {
        id: 107,
        description: "Do you want to email the Work Order to the Contractor now?"
    },
    {
        id: 108,
        description: "The Floor Area has been calculated based on the Room Measurements. Do you want to update the Property with this figure?"
    },
    {
        id: 109,
        description: "You are attempting to add a large number of files. Are you sure you want to continue?"
    },
    {
        id: 110,
        description: "Would you like to enable Automated Property Feedback?"
    },
    {
        id: 111,
        description: "The board status for this property has changed would you like to contact the board supplier?"
    },
    {
        id: 112,
        description: "You are about to add a new Company record. Doing so will create Bank Accounts and Company Configuration. Once saved you should enter Company and VAT Registration details via the System Configuration icon.  Are you still sure you wish to continue?"
    },
    {
        id: 113,
        description: "You are about to change this Contact into a Company. Doing so will create Bank Accounts and Company Configuration. If there are any Properties already linked to this Contact they will be transferred to the Company. Once saved you should enter Company and VAT Registration details via the System Configuration icon.  Are you still sure you wish to continue?"
    },
    {
        id: 114,
        description: "The company assigned to this property has been changed, would you like to update transactions linked to this property?"
    },
    {
        id: 115,
        description: "Would you like to update transactions linked to this contact's properties to the new company bank accounts?"
    },
    {
        id: 116,
        description: "Invoices have been created, would you like to send them now?"
    },
    {
        id: 117,
        description: "Customised letter templates have been detected. Would you like to download and import them?"
    },
    {
        id: 118,
        description: "Customised brochure templates have been detected. Would you like to download and import them?"
    },
    {
        id: 120,
        description: "This property has been assigned to a block management company, would you like to set the owner as the occupier?"
    },
    {
        id: 121,
        description: "RPost allows you to send audited, registered, electronically sign-able emails.  Would you like to create an RPost trial account?  (note account will take 1 or 2 days to become active after registration)"
    },
    {
        id: 122,
        description: "Is this company VAT registered?"
    },
    {
        id: 123,
        description: "Property Requirements have not been checked. Do you wish to continue saving?"
    },
    {
        id: 124,
        description: "Are you sure you want to close without saving?"
    },
    {
        id: 125,
        description: "Would you like to write a Section 21 letter?"
    },
    {
        id: 126,
        description: "The last statement was created over 30 days ago. Are you sure you want to undo this statement?"
    },
    {
        id: 127,
        description: "The Knowledge Base application could not be found. Would you like to install it?"
    },
    {
        id: 128,
        description: "A Tenancy is already in place for this Property and Contact. Are you sure you would like to continue adding this Pre-Tenancy?"
    },
    {
        id: 129,
        description: "This appointment is unconfirmed, are you sure you want to send confirmation emails?"
    },
    {
        id: 130,
        description: "Were the property feedback reports produced successfully?"
    },
    {
        id: 131,
        description: "Are you sure you want to close this email without sending?"
    },
    {
        id: 132,
        description: "Are you sure you want to close this SMS Text without sending?"
    },
    {
        id: 133,
        description: "A large number of system messages have been detected, would you like to acknowledge and close these messages now?"
    },
    {
        id: 134,
        description: "To comply with CMA (Competition & Markets Authority) obligations you must detail the fees you charge to Tenants. Acquaint will supply you with default text that you should adjust to include the fees you charge. Do you want to enter your Lettings Fees information text now?"
    },
    {
        id: 157,
        description: "You are about to enter bespoke Letting Fees for this property instead of using your default Fees. Are you sure you want to do this?"
    },
    {
        id: 158,
        description: "This transaction is linked to an outstanding invoice. Would you like to pay all transactions on the invoice or just this transaction?"
    },
    {
        id: 159,
        description: "A contact being charged doesn't have enough available funds to cover the charge. Are you sure you want to continue?"
    },
    {
        id: 160,
        description: "These email settings already exist. Do you wish to continue saving?"
    },
    {
        id: 161,
        description: "Does your Local Authority / Council require that Landlord’s register and licence their Properties? If so, answer \"Yes\" and Acquaint will help manage these registrations."
    },
    {
        id: 162,
        description: "There aren't enough cleared fees in this account to cover this refund. Are you sure you want to do this?"
    },
    {
        id: 163,
        description: "The contact you're transferring funds from doesn't have enough available credit to cover this transfer. Are you sure you want to do this?"
    },
    {
        id: 164,
        description: "You're cancelling a Cross Charge linked to a Work Order, would you like to set the status of the Work Order to completed?"
    },
    {
        id: 165,
        description: "You are paying a bill out of the company's client account. Are you sure you want to do this? If you do this you will need to transfer funds from another account to cover this bill."
    },
    {
        id: 166,
        description: "There are existing Active Certificates of this Type for this Property / Contact. Do you want to set them as Inactive?"
    },
    {
        id: 167,
        description: "Would you like to update the design of your marketing emails?"
    },
    {
        id: 168,
        description: "This process cannot be undone. Are you really sure you want to delete this Work Order?"
    },
    {
        id: 169,
        description: "This process cannot be undone. Are you really sure you want to delete this Certificate?"
    },
    {
        id: 170,
        description: "Would you like to email the contact who submitted the Maintenance Request?"
    },
    {
        id: 171,
        description: "The account that the contractor will be paid from is different to the account(s) that will be charged. A transfer between these accounts will occur to ensure that there are funds available to pay the contractor. Are you sure you want to continue?"
    },
    {
        id: 172,
        description: "The total amount of Let Only Fees does not match the amount that's been entered in the Tenancy Management & Commission Details section. Are you sure you want to continue?"
    },
    {
        id: 173,
        description: "The price against the property does not match the rental amount of the last tenancy. Would you like to update the price of the property?"
    },
    {
        id: 174,
        description: "Would you like to submit a deposit return request to the Custodial Scheme?"
    },
    {
        id: 175,
        description: "A deposit return request has already been submitted to the Custodial Scheme for this Tenancy. Are you sure you want to continue?"
    },
    {
        id: 176,
        description: "The date/time of your PC might be incorrect. Are you sure you want to continue running Acquaint?"
    },
    {
        id: 177,
        description: "It appears you have not run Acquaint on this PC for over 7 days, but it could also mean that the date/time of your PC is incorrect. Are you sure you want to continue running Acquaint?"
    },
    {
        id: 178,
        description: "Would you like to install the Acquaint Add In for Microsoft Word?"
    },
    {
        id: 179,
        description: "There is an unassigned split percentage this will be assigned to the primary landlord. Are you sure you want to do this?"
    },
    {
        id: 180,
        description: "Would you like to add the Block this company is managing?"
    },
    {
        id: 181,
        description: "This Task is linked to a Call in the Call Log. Are you sure you want to close it without saving?"
    },
    {
        id: 182,
        description: "This process will set the Transfer Deposit flag to Not Required for Deposit Transactions that are already in a Deposit Bank Account. Are you sure you want to continue?"
    },
    {
        id: 183,
        description: "Would you like to print the Statement now?"
    },
    {
        id: 184,
        description: "Acquaint is not linked to your Inventory Base account. Would you like to do this now?"
    },
    {
        id: 185,
        description: "Once Consolidated Payments has been switched on it is very difficult to reverse. Are you sure you want to do this?"
    },
    {
        id: 186,
        description: "The LogMeIn Hamachi software is not currently running,  this will prevent you from logging into Acquaint. Would you like Acquaint to try and restart it?"
    },
    {
        id: 187,
        description: "The ZeroTier software is not currently running,  this will prevent you from logging into Acquaint. Would you like Acquaint to try and restart it?"
    },
    {
        id: 188,
        description: "The SQL Server database is not currently running, this will prevent all users from logging into Acquaint. Would you like Acquaint to try and restart it?"
    },
    {
        id: 189,
        description: "Would you like to import this property from Lonres?"
    },
    {
        id: 190,
        description: "This property has already been imported from Lonres. Would you like to update it?"
    },
    {
        id: 191,
        description: "Do you want to assign this Card/Fob to these Property Keys?"
    },
    {
        id: 192,
        description: "Do you want to assign this Card/Fob to this Contact?"
    },
    {
        id: 193,
        description: "Were the invoices sent successfully?"
    },
    {
        id: 194,
        description: "Acquaint failed to load correctly the last time you ran it. Would you like to step through the functions that may have caused this?"
    },
    {
        id: 195,
        description: "Do you want to run this step?"
    },
    {
        id: 196,
        description: "The Client Bank Account assigned to this Contact has been changed, would you like to update all transactions linked to this Contact?"
    },
    {
        id: 197,
        description: "The Deposit Bank Account assigned to this Contact has been changed, would you like to update all transactions linked to this Contact?"
    },
    {
        id: 198,
        description: "No [TAG1] has been selected. Do you want to select one?"
    },
    {
        id: 199,
        description: "As the selected contact is a Landlord the Payment Run process will pay this Charge automatically. Are you sure you want continue paying this Charge manually?"
    },
    {
        id: 200,
        description: "You have already sent this Contact's details to your [TAG1]. Do you want to resend them?"
    },
    {
        id: 201,
        description: "Would you like to send a Proof of ID request to Planet Verify?"
    },
    {
        id: 202,
        description: "This Property Chain Item is linked to another Property Chain Item. Are you sure you want to make it inactive?"
    },
    {
        id: 203,
        description: "You are changing a Completed Sales Property to Available. Are you reselling this Property?"
    },
    {
        id: 204,
        description: "Proof of ID has already been obtained for this contact. Are you sure you want to perform a new ID/AML Check?"
    },
    {
        id: 205,
        description: "A Veriphy IDAML Check has been completed and a Proof of ID certificate has been created. Would you like to view the ID/AML Check result?"
    },
    {
        id: 206,
        description: "You will need to transfer money from your Current account to your Client account to cover these Rent Guarantee Payments. Are you sure you want to continue?"
    },
    {
        id: 207,
        description: "This process will remove all personal information such as name, address, emails, telephone numbers, etc. Are you sure you want to anonymise this Contact?"
    },
    {
        id: 208,
        description: "This process cannot be undone. Are you really sure you want to anonymise this Contact?"
    },
    {
        id: 209,
        description: "For General Data Protection Regulations (GDPR) would you like to send this Contact the Marketing Preferences Email which will allow them to update their preferences?"
    },
    {
        id: 210,
        description: "This Contact has not subscribed to receive Marketing correspondence from you. If you continue you may be breaching regulations. Are you sure you want to continue?"
    },
    {
        id: 211,
        description: "For General Data Protection Regulations (GDPR) you need to confirm that the Contact has given clear verbal consent to change their Marketing Preferences. If this is the case an Event Log record will be created as an audit of these changes. Please confirm that the Contact has given clear verbal consent?"
    },
    {
        id: 212,
        description: "Recurring Fees have already been set up for some of the selected contacts and properties. These recurring fees will be replaced. Do you want to continue?"
    },
    {
        id: 213,
        description: "The price against the property does not match the rental amount of this tenancy. Would you like to update the price of the property?"
    },
    {
        id: 214,
        description: "Recurring Fees have been created. Would you like to send an Invoice to the Contact?"
    },
    {
        id: 215,
        description: "Would you like to create an Invoice for the Credit Note?"
    },
    {
        id: 216,
        description: "This process cannot be undone. Are you really sure you want to anonymise these Contacts?"
    },
    {
        id: 217,
        description: "If you do not Accept the Terms & Conditions then you will be unable to use Acquaint. Are you sure you wish to cancel and exit Acquaint?"
    },
    {
        id: 218,
        description: "Would you like to send this Tenancy to Tenant Shop?"
    },
    {
        id: 219,
        description: "Are you sure you want to close without sending this document to Signable?"
    },
    {
        id: 220,
        description: "The selected file(s) will be copied to Acquaint's folder structure. Would you like to delete the original file(s)?"
    },
    {
        id: 221,
        description: "Are you producing these Address Labels for marketing purposes?  If you answer “Yes” only Contacts that have agreed to receive marketing from you will be included."
    },
    {
        id: 222,
        description: "It appears that your computer time is not correct. Currently your time is [TAG1], however we believe it should be [TAG2]. We strongly recommend that you do not continue loading Acquaint until your time has been changed to the correct time. Would you like to amend your computer time settings now?"
    },
    {
        id: 223,
        description: "This Property cannot be uploaded to the internet due to the following issues. [TAG1] Would you like to continue saving the Property?"
    },
    {
        id: 224,
        description: "Deleting a Tenancy will also attempt to delete all Transactions linked to it. Normally you will only delete a Tenancy if it’s been added by mistake. Are you sure you want to delete this Tenancy?"
    },
    {
        id: 225,
        description: "A Property Area already exists with this Description. Are you sure you want to continue saving?"
    },
    {
        id: 226,
        description: "Configuration has been changed. Would you like to run the Key Performance Indicators now?"
    },
    {
        id: 227,
        description: "This Work Order is linked to a Certificate Renewal. Would you like to create a new Certificate now?"
    },
    {
        id: 228,
        description: "This Work Order is linked to a Certificate. Would you like to update the Certificate now?"
    },
    {
        id: 229,
        description: "Would you like to reupload all images? This should only be done if images are missing from your website."
    },
    {
        id: 230,
        description: "Your Payment Export file has been created. Would you like to open it now to view its contents?"
    },
    {
        id: 231,
        description: "Would you like to email this Certificate to relevant Contacts?"
    },
    {
        id: 232,
        description: "Would you like to email the Tenant relevant Certificates for this Property?"
    },
    {
        id: 233,
        description: "This Area is assigned to a different branch. Do you want to re-assign this property to this branch as well : [TAG1] ?"
    },
    {
        id: 234,
        description: "This process will close Acquaint for all currently logged in users irrespective of what they're doing. This may take a couple minutes to complete. You should only do this if you have been unable to contact a user. Are you sure you want to continue?"
    },
    {
        id: 235,
        description: "The deposit amount is above the legal maximum deposit. Are you sure you want to continue?"
    },
    {
        id: 236,
        description: "This property does not have a valid Energy Performance Certificate. Marketing a property without one is breaking legislation and could result in a significant fine. [TAG1]"
    },
    {
        id: 237,
        description: "The holding deposit is more than 1 week's rent. Are you sure you want to continue?"
    },
    {
        id: 238,
        description: "You are about to send a Job Request to Countrywide Signs. Please confirm you wish to continue?"
    },
    {
        id: 239,
        description: "This transaction was part of a Payment Run.  To save time, do you want to include all the other transactions in the same run?  The run included [TAG1] payments and totalled [TAG2]."
    },
    {
        id: 240,
        description: "Proof of ID has already been obtained for this contact. Are you sure you want to perform a new Credit Safe Check?"
    },
    {
        id: 241,
        description: "A Credit Safe Check has been completed and a Proof of ID certificate has been created. Would you like to view the results?"
    },
    {
        id: 242,
        description: "You are part way through a Bank Reconciliation.  Do you wish to load this now and continue to complete it?"
    },
    {
        id: 243,
        description: "These details require saving before you can attach an external document. Would you like to save details now?"
    },
    {
        id: 244,
        description: "Would you like to send this Offer to the relevant parties?"
    },
    {
        id: 245,
        description: "You are saving this Bank Reconciliation with a variance. Any variance indicates that figures in Acquaint do not match your actual Bank Account and therefore Acquaint will not be able to accurately provide you with Account Balances. You can save the Reconciliation and edit it at a later date to correct the Variance. Do you want to continue saving?"
    },
    {
        id: 246,
        description: "This email contains unsecure links. This may cause the email to be treated as spam. Are you sure you want to continue?"
    },
    {
        id: 247,
        description: "A deposit account statement has been created for the Tenant. Would you like to view it or send it to the Tenant now?"
    },
    {
        id: 248,
        description: "The holding deposit is more than 1 week's rent and the deposit amount is above the legal maximum deposit. Are you sure you want to continue?"
    },
    {
        id: 249,
        description: "Would you like to email the Sales Memorandum to the relevant parties?"
    },
    {
        id: 250,
        description: "A Work Order with the same reference has already been added for this Contractor. Are you sure you want to continue?"
    },
    {
        id: 251,
        description: "Would you like to send this Tenancy to Notify?"
    },
    {
        id: 252,
        description: "Are you sure you want to assign this to a different branch?"
    },
    {
        id: 253,
        description: "The Tenant's deposit has been registered with the TDS. Would you like to email the Tenant a copy of the Deposit Protection Certificate?"
    },
    {
        id: 254,
        description: "The commission for this Property has been changed. Would you like to update the commission of future Rents for Current Tenancies linked to this Property?"
    },
    {
        id: 255,
        description: "Not all Transactions have been matched. Are you sure you want to continue?"
    },
    {
        id: 256,
        description: "Are you sure you want to reset the Property Chain? This will delete all items in the chain, including those that have been added manually."
    },
    {
        id: 257,
        description: "This Property is a Link. Would you prefer to use the Primary record instead?"
    },
    {
        id: 258,
        description: "Would you like to send Quotation Requests for this Work Order?"
    },
    {
        id: 259,
        description: "You are about to create default Usernames for all Users that currently don’t have one set. Would you also like to send an email to each User to inform them of their new Username?"
    },
    {
        id: 360,
        description: "The provided MPRN and property address in Acquaint do not match. Please confirm this is the correct property address to assign to the utility switch:"
    },
    {
        id: 361,
        description: "You don’t have a watermark available. Would you like send a request to Bright Logic Support to create one for you?"
    },
    {
        id: 362,
        description: "Do you want to send this to Property Button?"
    },
    {
        id: 363,
        description: "It appears that settings on your PC or Network are blocking Acquaint from communicating with the web services/API hosted at api.brightlogic.co.uk. Please raise this issue with your IT providers to check your firewalls and antivirus. You can Continue but certain functions in Acquaint will be unavailable until this is resolved."
    },
    {
        id: 364,
        description: "You have reduced the Price of this Property. Would you like to re-include Applicants for Matching that were previously \"Not Interested\"?"
    },
    {
        id: 365,
        description: "To adhere to National Trading Standards Material Interest regulations, you need to specify the Services connected to this property and Type of Supply. Do you wish to continue saving without doing this?"
    },
    {
        id: 366,
        description: "Would you like to email the Contact a Payment Link so they can pay online via Credit Card / Debit Card / Open Banking?"
    },
    {
        id: 367,
        description: "These are your recently received Payments via Payment Links.  Are you happy for the Home Page Reminder to be removed for them?"
    },
    {
        id: 368,
        description: "An ID/AML Check has been completed and a Proof of ID certificate has been created. Would you like to view the result?"
    },
    {
        id: 369,
        description: "This process may take up to 30 seconds. Are you sure you want to continue?"
    }
];
